import * as React from "react";

function LinkDiagonalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'current',
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    width: props.width || '32px'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'current',
    fillRule: "evenodd",
    d: "M13.15 18.81a7.49 7.49 0 005.31 2.15 7.49 7.49 0 005.31-2.19l4-4a7.63 7.63 0 000-10.62 7.63 7.63 0 00-10.62 0l-2 2 1.42 1.46 2-2a5.57 5.57 0 017.78 0 5.57 5.57 0 010 7.78l-4 4a5.57 5.57 0 01-7.78 0l-1.42 1.42zm-9 9a7.49 7.49 0 005.31 2.15 7.49 7.49 0 005.31-2.15l2-2-1.42-1.42-2 2a5.57 5.57 0 01-7.78 0 5.57 5.57 0 010-7.78l4-4a5.55 5.55 0 017.78 0l1.42-1.42a7.58 7.58 0 00-10.62 0l-4 4a7.63 7.63 0 000 10.62z",
    clipRule: "evenodd"
  }));
}

export default LinkDiagonalIcon;